import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkSpacing } from './uitk-spacing.esm.js';
import styles from './uitk-spacing.css';
var getClassNameList = classNames.bind(styles);
var UitkSpacingHr = function (props) {
  var blockMargin = props.blockMargin;
  var baseClass = 'uitk-spacing-hr';
  return React.createElement(UitkSpacing, {
    border: ['blockstart'],
    className: getClassNameList(baseClass),
    margin: {
      block: blockMargin
    }
  }, React.createElement("hr", null));
};
UitkSpacingHr.defaultProps = {
  blockMargin: 'four'
};
export { UitkSpacingHr };